import * as React from "react";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import styled from "styled-components";
import { useFieldError, FieldErrorProps } from "Hooks/useFieldError";
import { IMaskMixin } from "react-imask";
import { isNoU } from "Utils/ObjectUtils";
import { StyledInputLabel } from "Components/Shared/StyledComponents";

type Props = TextFieldProps &
  FieldErrorProps & {
    label?: string;
    name?: string;
    mask?: string | NumberConstructor;
    unmask?: boolean | "typed";
    max?: number;
    min?: number;
    onMaskInputChange?: (val: string) => void;
  };

const StyledWrapper = styled.div``;

const StyledInput = styled(TextField)`
  .ibis-MuiInputBase-input {
    padding: 10px 12px;
  }

  .ibis-MuiOutlinedInput-notchedOutline {
    border-color: ${props => props.theme.colors.border};
  }
`;

const MaskedInput = IMaskMixin(
  ({ ref, ...props }: { ref: React.RefObject<HTMLDivElement> }) => (
    <StyledInput {...props} ref={ref} />
  ),
);

export const TextInput: React.FunctionComponent<Props> = props => {
  const { hasError, originalProps } = useFieldError(props);
  const {
    label,
    name,
    mask,
    unmask,
    max,
    min,
    onMaskInputChange,
    value,
    ...rest
  } = originalProps;

  const handleMaskInputChange = (nextValue: string) => {
    onMaskInputChange && onMaskInputChange(nextValue);
  };

  return (
    <StyledWrapper className={"input-wrapper"}>
      <StyledInputLabel
        className={"form-label"}
        htmlFor={name}
        hasError={hasError}
      >
        {label}
      </StyledInputLabel>
      {isNoU(mask) ? (
        <StyledInput
          name={name}
          id={name}
          variant={"outlined"}
          fullWidth
          error={hasError}
          value={value}
          {...rest}
        ></StyledInput>
      ) : (
        <MaskedInput
          mask={mask}
          unmask={unmask ?? true}
          radix=","
          thousandsSeparator={" "}
          max={max ?? Number.MAX_SAFE_INTEGER}
          min={min ?? Number.MIN_SAFE_INTEGER}
          value={value}
          name={name}
          id={name}
          variant={"outlined"}
          fullWidth
          error={hasError}
          onAccept={handleMaskInputChange}
          {...rest}
        ></MaskedInput>
      )}
    </StyledWrapper>
  );
};
